import { useEffect, useState } from 'react';

export const useElementVisibility = (
  selector: string,
  enabled: boolean = true,
  rootMargin: string = '0px',
) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const setupObserver = () => {
      const element = document.querySelector(selector);

      if (!element) {
        requestAnimationFrame(setupObserver);
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0,
          rootMargin,
        },
      );

      observer.observe(element);

      return observer;
    };

    const observer = setupObserver();

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [selector, enabled, rootMargin]);

  return isVisible;
};
